export default __webpack_public_path__ + "static/media/business_report-ioc.eda3b807.png";